import { Languages } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";
import { useLanguagePreference } from "@/hooks/useLanguagePreference";

export function LanguageSwitcher({ compact = false, className }: { compact?: boolean; className?: string }) {
  const { language, changeLanguage, options } = useLanguagePreference();
  const activeLabel = options.find((option) => option.value === language)?.label ?? "Francais";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size={compact ? "sm" : "default"} className={cn("gap-2", className)}>
          <Languages className="h-4 w-4" />
          <span>{compact ? language.toUpperCase() : activeLabel}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {options.map((option) => (
          <DropdownMenuItem
            key={option.value}
            onClick={() => void changeLanguage(option.value)}
            className={language === option.value ? "font-semibold" : ""}
          >
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
